import '../styles/compra.scss'
import { Button } from '../componentes/Button'
import { useNavigate } from 'react-router-dom'
import { FormEvent, useCallback, useEffect, useState } from 'react'
import { useUserAuth } from '../hooks/useUserAuth'
import api from '../services/api'
import pagarMeAPI from '../services/pagarme'
import { CardDetails } from '../services/pagarme'
import InputMask from 'react-input-mask'
import { Header } from '../componentes/Header'
import copy from "copy-to-clipboard"
import { toast } from 'react-toastify'
import { TailSpin } from 'react-loader-spinner'
import CepService from '../services/brasilapi'


type CardType = {
    cardnumber: string
    expmonth: string
    expyear: string
    cvv: string
    document: string
    address: {
        country: string
        state: string
        city: string
        zip_code: string
        line_1: string
    }
}

type OptionType = {
    value: string
    label: string
    price: string
}



export function Compra() {
    const [isLoading, setIsLoading] = useState(false)
    const history = useNavigate()
    const { user } = useUserAuth()
    const [card, setCard] = useState<CardType>({
        cardnumber: '',
        expmonth: '',
        expyear: '',
        cvv: '',
        document: '',
        address: {
            country: '',
            state: '',
            city: '',
            zip_code: '',
            line_1: ''
        }
    })
    const [quant, setQuant] = useState('2')
    const [nome, setNome] = useState('')
    const [email, setEmail] = useState('')
    const [valor, setValor] = useState('')
    const [valorreal, setValorreal] = useState('10')
    const [selectedOption, setSelectedOption] = useState('pix')
    const [selectedCompra, setSelectedCompra] = useState('compra')
    const [showhide, setShowhide] = useState('hidden')
    const [exibeQRCode, setExibeQRCode] = useState('hidden')
    const [exibeForm, setExibeForm] = useState('show')
    const [QRCode, setQRCode] = useState('')
    const [linkPagamento, setLinkPagamento] = useState('')
    const [idPayment, setIdPayment] = useState('')
    const [options, setOptions] = useState<OptionType[]>([])


    function validateCardDetails(card: CardType, nome: string, email: string): boolean {
        if (!nome || !email) {
            toast.warning('Nome e E-mail são obrigatórios');
            return false;
        }
        if (!card.cardnumber || !card.expmonth || !card.expyear || !card.cvv || !card.document || !card.address.zip_code) {
            toast.warning('Todos os campos do cartão de crédito são obrigatórios');
            return false;
        }
        return true;
    }

    async function handleCompra(event: FormEvent) {
        event.preventDefault()
        setIsLoading(true)
        if (selectedOption === "pix") {
            await api.post('pagarme/pix/', new URLSearchParams({
                nome: nome,
                email: email,
                valor: valor,
                valorreal: valorreal,
                quant: quant
            }))
                .then((response) => {
                    setIsLoading(false)
                    toast.success(response?.data.msg)
                    setExibeQRCode('show')
                    setExibeForm('hidden')
                    setQRCode(response?.data.qr_code_url)
                    setLinkPagamento(response?.data.qr_code)
                    setIdPayment(response?.data.id_payment)
                })
                .catch((e) => {
                    if (e.response) {
                        setIsLoading(false)
                        toast.warning(e.response?.data.error)
                    }

                })

        } else {
            if (!validateCardDetails(card, nome, email)) {
                setIsLoading(false)
                return;
            }
            try {
                const cardDetails: CardDetails = {
                    number: card.cardnumber.replaceAll(" ", ""),
                    holder_name: nome,
                    exp_month: card.expmonth,
                    exp_year: card.expyear,
                    cvv: card.cvv,
                    label: "Visa"
                }
                const token = await pagarMeAPI.generateToken(cardDetails)
                await api.post('pagarme/credit_card/', new URLSearchParams({
                    nome: nome,
                    email: email,
                    valor: valor,
                    valorreal: valorreal,
                    quant: quant,
                    card_token: token.id,
                    document: card.document.replaceAll(".", "").replaceAll("-", ""),
                    zip_code: card.address.zip_code,
                    country: card.address.country,
                    state: card.address.state,
                    city: card.address.city,
                    line_1: card.address.line_1

                }))
                    .then((response) => {
                        setIsLoading(false)
                        toast.success(response?.data.msg)
                        history('/')
                    })
                    .catch((e) => {
                        if (e.response) {
                            setIsLoading(false)
                            toast.warning(e.response?.data.error)
                        }

                    })
            } catch (error) {
                setIsLoading(false)
                toast.error((error as Error).message)
            }

        }

    }

    const atualizaValor = useCallback(async (event: string) => {
        const selectedOption = options.find(option => option.value === event);
        if (selectedOption) {
            setQuant(selectedOption.value)
            let valorTemp = parseFloat(selectedOption.price)
            setValor(valorTemp.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' }))
            setValorreal(selectedOption.price);
        }
    }, [options])

    function handleChangePixCard(value: string) {
        setSelectedOption(value)
        if (value === "pix") {
            setShowhide('hidden')
        } else {
            setShowhide('show')
        }
    }

    async function handleValidaPix() {
        setIsLoading(true)
        await api.post('pagarme/validapixVoto/', new URLSearchParams({
            id_payment: idPayment
        }))
            .then((response) => {
                setIsLoading(false)
                toast.success(response?.data.msg)
                if (response?.data.status) {
                    history('/')
                }
            })
            .catch((e) => {
                if (e.response) {
                    toast.warning(e.response?.data.error)
                }

            })

    }

    async function handleZipCode(value: string) {
        if (value.replaceAll("_", "").trim().length === 10) {
            try {
                const addressApi = await CepService.getAddress(value)
                setCard({ ...card, address: addressApi })
            } catch (error) {
                toast.error("Erro: " + error)
            }

        } else {
            setCard({ ...card, address: { ...card.address, zip_code: value } })
        }

    }

    async function handleCopiaLink() {
        copy(linkPagamento)
        toast.success("Código Copiado com sucesso")
    }

    async function handleChangeCompra(value: string) {
        setSelectedCompra(value)
        history('/' + value)
    }

    useEffect(() => {
        const carregaDados = async () => {
            const response = await api.get("pagarme/listPrice")
            setOptions(response.data)

            if (user?.name) {
                setNome(user?.name)
            }
            if (user?.email) {
                setEmail(user?.email)
            }
        }
        carregaDados()
    }, [user?.name, user?.email])

    useEffect(() => {
        if (options.length > 0) {
            atualizaValor("2")
        }
    }, [options, atualizaValor])

    return (
        <div id="page-room">
            <Header />
            <main className='content'>
                {isLoading && (
                    <div className="loader-overlay">
                        <div className="loader-container">
                            <TailSpin
                                height="100"
                                width="100"
                                color="#00BFFF"
                                ariaLabel="loading"
                            />
                        </div>
                    </div>
                )
                }
                <div className='room-title'>
                    <h1>Compra</h1>
                    <div className='ranking-filter-button'>
                        <select className='filter-select' onChange={event => handleChangeCompra(event.target.value)} value={selectedCompra} >
                            <option value="compra">Compra</option>
                            <option value="pedido">Pedidos</option>
                        </select>
                    </div>
                </div>
                <div className={'compra-list ' + exibeForm}>
                    <form onSubmit={handleCompra}>
                        <select className='filter-select' onChange={event => handleChangePixCard(event.target.value)} value={selectedOption} >
                            <option value="pix">PIX</option>
                            <option value="cc">Cartão de Crédito</option>
                        </select>
                        <input
                            readOnly
                            type='text'
                            placeholder='Nome'
                            value={nome}
                        />
                        <input
                            readOnly
                            type='text'
                            placeholder='E-mail'
                            value={email}
                        />
                        <div className='flex-line'>
                            <InputMask
                                className={`input-mask-seventy ${showhide}`}
                                name="cardnumber"
                                mask="9999 9999 9999 9999"
                                value={card.cardnumber}
                                onChange={event => setCard({ ...card, cardnumber: event.target.value })}
                                placeholder='Cartão de Crédito'
                                alwaysShowMask={false}
                            />
                            <InputMask
                                className={`input-mask-thirty ${showhide}`}
                                name="cvv"
                                mask="999"
                                value={card.cvv}
                                onChange={event => setCard({ ...card, cvv: event.target.value })}
                                placeholder='CVV'
                                alwaysShowMask={false}
                            />
                        </div>
                        <div className='flex-line'>
                            <InputMask
                                className={`input-mask-fifty ${showhide}`}
                                name="expmonth"
                                mask="99"
                                value={card.expmonth}
                                onChange={event => setCard({ ...card, expmonth: event.target.value })}
                                placeholder='Mês Expiração'
                                alwaysShowMask={false}
                            />
                            <InputMask
                                className={`input-mask-fifty ${showhide}`}
                                name="expyear"
                                mask="99"
                                value={card.expyear}
                                onChange={event => setCard({ ...card, expyear: event.target.value })}
                                placeholder='Ano Expiração'
                                alwaysShowMask={false}
                            />
                        </div>
                        <div className='flex-line'>
                            <InputMask
                                className={`input-mask-sixty ${showhide}`}
                                name="document"
                                mask="999.999.999-99"
                                value={card.document}
                                onChange={event => setCard({ ...card, document: event.target.value })}
                                placeholder='CPF Titular Cartão'
                                alwaysShowMask={false}
                            />
                            <InputMask
                                className={`input-mask-forty ${showhide}`}
                                name="zipcode"
                                mask="99.999-999"
                                value={card.address.zip_code}
                                onChange={event => handleZipCode(event.target.value)}
                                placeholder='CEP Titular'
                                alwaysShowMask={false}
                            />
                        </div>
                        <div className='flex-line'>
                            <input
                                className={`${showhide}`}
                                readOnly
                                type='text'
                                placeholder='Cidade'
                                value={card.address.city}
                            />
                            <input
                                className={`${showhide}`}
                                readOnly
                                type='text'
                                placeholder='Estado'
                                value={card.address.state}
                            />
                        </div>
                        <input
                            className={`${showhide}`}
                            readOnly
                            type='text'
                            placeholder='Rua'
                            value={card.address.line_1}
                        />
                        <select name="quant" value={quant} onChange={event => atualizaValor(event.target.value)} >
                            {options.map(option => (
                                <option key={option.value} value={option.value}>
                                    {option.label}
                                </option>
                            ))}
                        </select>

                        <input
                            readOnly
                            type='text'
                            placeholder='Valor'
                            value={valor}
                        />

                        <Button>Comprar</Button>
                    </form>

                </div>
                <div className={'compra-list ' + exibeQRCode}>
                    <h3>Leia o QRCode ou copie o link de pagamento</h3>
                    <img src={QRCode} alt='Qr Code' />
                    <label>{linkPagamento}</label>
                    <Button onClick={handleCopiaLink}>Copiar Código PIX</Button>
                    <div className="separator">Já efetuei o Pagamento</div>
                    <Button onClick={handleValidaPix}>Liberar compra</Button>
                </div>
            </main >
        </div >
    )
}
